import { useEffect, useState } from 'react';
import { auth } from '../config/firebase';
import userService from '../services/userService';

export function useCurrentUser() {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(async (firebaseUser) => {
      if (firebaseUser && firebaseUser.email) {
        try {
          // Get user by email instead of UID
          const users = await userService.getUserByEmail(firebaseUser.email);
          if (users && users.length > 0) {
            const userData = users[0]; // Get the first matching user
            setUser({ uid: firebaseUser.uid, ...userData });
          } else {
            setUser(null);
          }
        } catch (error) {
          console.error('Error fetching user by email:', error);
          setUser(null);
        }
      } else {
        setUser(null);
      }
    });

    return () => unsubscribe();
  }, []);

  return user;
}
